import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spinner" }

import { computed } from "vue";

interface Props {
  color?: string;
  size?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSpinner',
  props: {
    color: {},
    size: {}
  },
  setup(__props: any) {

const props = __props;

const colorCode = computed(() => {
  switch (props.color) {
    case "pink":
      return "#cf2485";
    case "dark":
      return "#444242";
    default:
      return "#fff";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bounce1",
      style: _normalizeStyle(`background-color: ${colorCode.value}; width: ${
        _ctx.size ? _ctx.size : 8
      }px; height: ${_ctx.size ? _ctx.size : 8}px;`)
    }, null, 4),
    _createElementVNode("div", {
      class: "bounce2",
      style: _normalizeStyle(`background-color: ${colorCode.value}; width:  ${
        _ctx.size ? _ctx.size : 8
      }px; height: ${_ctx.size ? _ctx.size : 8}px;`)
    }, null, 4),
    _createElementVNode("div", {
      class: "bounce3",
      style: _normalizeStyle(`background-color: ${colorCode.value}; width:  ${
        _ctx.size ? _ctx.size : 8
      }px; height: ${_ctx.size ? _ctx.size : 8}px;`)
    }, null, 4)
  ]))
}
}

})